import {OutlinedInput, withStyles} from '@material-ui/core';
import {GET_8_PIXEL_BOX} from '../../../style/variable';
const PaymentsStyledInput = withStyles({
  root: {
    borderRadius: `${GET_8_PIXEL_BOX(0.5)}`
  }
  //   marginDense: {
  //     // marginTop: `${GET_8_PIXEL_BOX(1)}`
  //   }
})(OutlinedInput);

export default PaymentsStyledInput;
